import React, { useEffect, useState } from "react";
import cn from "classnames";
import Icon from "../../brand/Icon";

import { AccordionProps } from "./Accordion.props";
import styles from "./Accordion.module.scss";
import Skeleton from "react-loading-skeleton";
import { generateId } from "../../utilities/generateId";

/**
 * @deprecated use `import { Collapse } from "capitalrx-component-2.0/lib/general"
 */
const Accordion: React.FC<AccordionProps> = ({
  id,
  testId,
  children,
  title,
  label,
  disabled = false,
  className,
  accordionHeaderClass,
  accordionButtonClass,
  accordionContentClass,
  expand = false,
  tagContent,
  isLoading = false,
  disableExpand = false,
}: AccordionProps) => {
  const [open, setOpen] = useState(expand);
  const uniqueId = generateId();

  useEffect(() => {
    setOpen(expand);
  }, [expand]);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    if (!disableExpand) {
      setOpen((open) => !open);
    }
  };

  const accordionContainerClasses = cn(styles["accordion"], className);
  const accordionContentClasses = cn(styles["accordion-content"], { [styles["accordion-body--collapsed"]]: !open }, accordionContentClass);
  const accordionButtonClasses = cn(
    styles["accordion-button"],
    { [styles["open"]]: open },
    { [styles["disabled"]]: disabled },
    accordionButtonClass,
  );
  const accordionHeaderClasses = cn(styles["accordion-left"], accordionHeaderClass);

  const accordionHeader = (
    <>
      <span className={accordionHeaderClasses}>
        <span>
          {label ? <label className={styles["accordion-left-label"]}>{label}</label> : null}
          {isLoading ? <Skeleton width={100} /> : title}
        </span>
        {tagContent}
      </span>
      {isLoading || disableExpand ? null : <Icon id={id} name={"carat-down"} className={styles["accordion-svg"]} ariaHidden="true" />}
    </>
  );

  return (
    <div className={accordionContainerClasses} data-testid={testId ? `test__${testId}` : undefined}>
      <button
        type="button"
        data-testid={testId ? `test__accordionButton-${testId}` : undefined}
        onClick={handleClick}
        className={accordionButtonClasses}
        aria-controls={uniqueId}
      >
        {accordionHeader}
      </button>
      <div className={accordionContentClasses} id={uniqueId}>
        {open ? children : null}
      </div>
    </div>
  );
};

export default Accordion;
